import _ from 'lodash';

// Page/Route types mapped to icons/labels etc
export const pageTypes = {
  viewPage: {
    icon: 'view-web',
    title: 'Page',
  },
  viewReport: {
    icon: 'print',
    title: 'Report',
  },
  viewList: {
    icon: 'view-list',
    title: 'List',
  },
  viewCalendar: {
    icon: 'calendar',
    title: 'Calendar',
  },
  viewDb: {
    icon: 'file-text',
    title: 'Database',
  },
  viewWebSolutions: {
    icon: 'print',
    title: 'Web Solutions',
  },
  history: {
    icon: 'time-restore',
    label: 'History',
  },
  favorite: {
    icon: 'time-restore',
    label: 'Favorite',
  },
};

export const getPageType = pageType => {
  return pageTypes[pageType] || pageTypes.viewPage;
};

export const getPageTitles = (pages, searchData) => {
  const titles = [];
  if (pages && pages.length) {
    for (const page of pages) {
      titles.push(_.get(searchData[page], 'title', ''));
    }
  }

  return titles;
};

export const menuDefs = {
  accounting: {
    icon: 'usd-circle',
    label: 'Accounting',
    color: '#b50938',
  },
  leasing: {
    icon: 'business-time',
    label: 'Leasing',
    color: '#005695',
  },
  equipment: {
    icon: 'handshake',
    label: 'Equipment',
    color: '#673ab7',
  },
  parts: {
    icon: 'truck',
    label: 'Parts',
    color: '#468847',
  },
  service: {
    icon: 'wrench',
    label: 'Service',
    color: '#d1451f',
  },
  system: {
    icon: 'hdd',
    label: 'System',
    color: '#989898',
  },
  solutions: {
    icon: 'globe',
    label: 'Web Solutions',
    link: 'WebSolution',
    color: '#cca63a',
  },
  calendar: {
    icon: 'calendar',
    label: 'Calendar',
    color: '#fff',
  },
};

export const whichMenuItem = location => {
  if (location === '/' || location === '/home') {
    return 'accounting';
  }

  if (/^\/SDC.*/.test(location)) {
    return 'calendar';
  }

  if (location === '/Favorites') {
    return 'favorites';
  }

  if (/^\/?(?:(?:list|db)\/)?A.*/.test(location) || location === '/menu/Accounting') {
    return 'accounting';
  }

  if (/^\/?(?:(?:list|db)\/)?L.*/.test(location) || location === '/menu/Leasing') {
    return 'leasing';
  }

  if (/^\/?(?:(?:list|db)\/)?P.*/.test(location) || location === '/menu/Parts') {
    return 'parts';
  }

  if (/^\/?(?:(?:list|db)\/)?S.*/.test(location) || location === '/menu/Service') {
    return 'service';
  }

  if (/^\/?(?:(?:list|db)\/)?U.*/.test(location) || location === '/menu/System') {
    return 'system';
  }

  if (/^\/?WEB.*/.test(location) || location === '/menu/WebSolution') {
    return 'solutions';
  }

  if (/^\/?(?:(?:list|db)\/)?E.*/.test(location) || location === '/menu/Equipment') {
    return 'equipment';
  }

  return '';
};
